import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black4};
  justify-content: space-between;
  padding-bottom: 16px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TitleText = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;
